import { createWebSocketStore } from 'src/components/#services/helpers';
export const getCategories = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_getCategories',
    },
});
export const createCategory = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_createCategory',
    },
});
export const editCategory = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_editCategory',
    },
});
export const getTasks = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_getTasks',
    },
});
export const getTask = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_getTask',
    },
});
export const createTask = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_createTask',
    },
});
export const editTask = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_editTask',
    },
});
export const deleteTask = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_deleteTask',
    },
});
export const getUsersTasks = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_getUsersTasks',
    },
});
export const getStats = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_getStats',
    },
});
export const moderateUserTask = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_moderateUserTask',
    },
});
export const sendUserMessage = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_sendUserMessage',
    },
});
export const getLeaderboardByWeek = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_getUsersRewardByPreviousWeek',
    },
});
export const getLeaderboardByMonth = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_getUsersRewardByLast30Days',
    },
});
export const getProfile = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_getUser',
    },
});
export const setBlackListStatus = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_setBlackListStatus',
    },
});
export const setSuspiciousStatus = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_setSuspiciousStatus',
    },
});
export const saveNoteToUser = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_setNoteToUser',
    },
});
export const findByUserName = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'realis-task-bot',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'taskEndpoints_findByUserName',
    },
});
